<template>
    <b-card title="" style="width: 100%; max-width: 500px; margin: auto;">
        <h4 class="text-primary font-weight-bold mb-2">สร้าง น.จ. (บริษัทนำคนต่างด้าวมาทำงานในประเทศ)</h4>
        <b-row>
            <b-col md="12">
                <b-form-group label="ชื่อบริษัท (น.จ.)" label-for="companyName">
                    <b-form-input v-model="formUser.companyName" placeholder="ชื่อบริษัท (น.จ.)"
                        :class="{ 'is-invalid': showError && !formUser.companyName }" />
                    <!-- <b-form-input id="username" placeholder="ชื่อผู้ใช้งาน" /> -->
                </b-form-group>
            </b-col>
            <b-col md="12">
                <b-form-group label="เบอร์โทร (น.จ.)" label-for="companyPhone">
                    <b-form-input v-model="formUser.companyPhone" placeholder="เบอร์โทร (น.จ.)" />
                    <!-- <b-form-input id="username" placeholder="ชื่อผู้ใช้งาน" /> -->
                </b-form-group>
            </b-col>
            <b-col md="12">
                <b-form-group label="ชื่อผู้ใช้งาน" label-for="username">
                    <b-form-input v-model="formUser.username" placeholder="ชื่อผู้ใช้งาน"
                        :class="{ 'is-invalid': showError && !formUser.username }" />
                    <!-- <b-form-input id="username" placeholder="ชื่อผู้ใช้งาน" /> -->
                </b-form-group>
            </b-col>
            <b-col md="12">
                <b-form-group label="รหัสผ่าน" label-for="password">
                    <b-form-input id="login-password" v-model="formUser.password" class="form-control-merge"
                        :type="formUser.passwordFieldType" name="login-password" placeholder="รหัสผ่าน"
                        :class="{ 'is-invalid': showError && !formUser.password }" />
                    <!-- <b-form-input v-model="formUser.password" placeholder="รหัสผ่าน"  /> -->
                </b-form-group>
            </b-col>

            <b-col md="12">
                <b-form-group label="เลือกสิทธิ์" label-for="role">
                    <b-form-select v-model="selected" :options="options"
                        :class="{ 'is-invalid': showError && !selected }" />
                    <!-- <b-card-text class="mt-1 mb-0">
          เลือกสิทธิ์: <strong>{{ selected }}</strong>
        </b-card-text> -->
                </b-form-group>
            </b-col>
            <b-col md="12">
                <b-form-group label="serial" label-for="serial">
                    <b-form-input id="login-serial" v-model="formUser.serial" class="form-control-merge"
                        :type="formUser.passwordFieldType" name="login-password" placeholder="serial"
                        :class="{ 'is-invalid': showError && !formUser.serial }" />
                    <!-- <b-form-input v-model="formUser.password" placeholder="รหัสผ่าน"  /> -->
                </b-form-group>
                <!-- <b-form-group label="serial" label-for="serial">
                    <b-form-input v-model="formUser.serial" placeholder="serial" />
                    
                </b-form-group> -->
            </b-col>
            <b-col md="6"> </b-col>

        </b-row>

        <b-col cols="12" class="text-center">
            <b-button variant="primary" type="submit" @click.prevent="validationForm">
                บันทึกข้อมูล
            </b-button>
        </b-col>

    </b-card>
</template>

<script>
import {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
} from "bootstrap-vue";
import { BCard, BCardText } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import API from "@/connect/config";
import axios from "axios";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
    components: {
        BTable,
        BAvatar,
        BBadge,
        BRow,
        BCard,
        BCardText,
        BCol,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BButton,
    },
    directives: {
        Ripple,
    },
    mixins: [togglePasswordVisibility],

    data() {
        return {
            perPage: 2,
            pageOptions: [2, 3, 100],
            totalRows: 1,
            currentPage: 1,
            sortBy: "",
            sortDesc: false,
            sortDirection: "asc",
            filter: null,
            filterOn: [],
            infoModal: {
                id: "info-modal",
                title: "",
                content: "",
            },
            fields: [
                {
                    key: "username",
                    label: "username",
                },
                {
                    key: "firstname",
                    label: "firstname",
                },
                {
                    key: "lastname",
                    label: "lastname",
                },
                {
                    key: "role",
                    label: "role",
                },
                { key: "action", label: "Actions" }, // ✅ เพิ่มตรงนี้
            ],
            items: [],
            selected: null,
            options: [
                { value: null, text: "-- เลือกสิทธิ์ --" },
                { value: "admin", text: "admin" },
            ],
            formUser: {
                companyName: "",
                companyPhone: "",
                username: "",
                password: "",
                passwordFieldType: "password",
                firstname: "",
                lastname: "",
                serial: "",
            },
            showError: false,

        };
    },
    computed: {
        sortOptions() {
            // Create an options list from our fields
            return this.fields
                .filter((f) => f.sortable)
                .map((f) => ({ text: f.label, value: f.key }));
        },
    },
    created() {
       // this.getDataTable();
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.items.length;
    },
    methods: {
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`;
            this.infoModal.content = JSON.stringify(item, null, 2);
            this.$root.$emit("bv::show::modal", this.infoModal.id, button);
        },
        resetInfoModal() {
            this.infoModal.title = "";
            this.infoModal.content = "";
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        editItem(item) {
            console.log("Edit:", item);
            // เพิ่ม logic แก้ไข
        },
        deleteItem(item) {
            console.log("Delete:", item);
            confirmText();
            // เพิ่ม logic ลบ
        },
        confirmText(item) {
            console.log(item);

            this.$swal({
                title: "ลบข้อมูล?",
                text: "คุณต้องการจะลบข้อมูล ใช่หรือไม่!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "ลบ",
                cancelButtonText: "ยกเลิก",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then(async (result) => {
                if (result.value) {
                    const refreshToken = localStorage.getItem("refresh_token");
                    await axios
                        .delete(`${API}deleteUserAccount`, {
                            data: {
                                userId: item.userId,
                            },
                            headers: {
                                Authorization: refreshToken, //await store.dispatch("getAuthorization"),
                            },
                        })
                        .then(async (el) => {
                            console.log(el.data.message);
                            if (el.data.message == "Delete Account Complete.") {
                                this.$swal({
                                    icon: "success",
                                    title: "ลบข้อมูล!",
                                    text: "ลบข้อมูลสำเร็จ",
                                    showCancelButton: false,
                                    showConfirmButton: true,
                                    timer: 1500,
                                    customClass: {
                                        confirmButton: "btn btn-success",
                                    },
                                });
                            }
                            this.getDataTable();
                        })
                        .catch((err) => {
                            if (err.response) {
                                console.error("❌ API Error:", err.response.status);
                                console.error("Response:", err.response.data);
                            } else {
                                console.error("❌ Error:", err.message);
                            }
                        });

                    return;
                }
            });
        },

        async getDataTable() {
            try {
                const jwt = JSON.parse(localStorage.getItem("company_jwt"));

                const params = {
                    companyId: jwt.companyId,
                    userId: jwt.userId,
                    _page: this.currentPage,
                    _limit: this.perPage,
                    _sort: "-1",
                };

                const res = await axios.get(`${API}allUserFromCompany`, {
                    params,
                    headers: {
                      Authorization: await store.dispatch("getAuthorization"),
                    },
                });
                if (!res.data.message[0] || !res.data.message[0].total) {
                    this.items = [];
                    this.totalRows = 0;
                    return;
                }
                console.log("API Response", res.data.message);
                console.log("API Response totalRows", res.data.message[0].total);
                this.items = res.data.message[0].results;
                this.totalRows = res.data.message[0].total;
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
            } finally {
                this.isBusy = false;
            }

            return;
            const jwt = JSON.parse(localStorage.getItem("company_jwt"));
            console.log(jwt);
            await axios
                .get(
                    `${API}allUserFromCompany?companyId=${jwt.companyId}&userId=${jwt.userId}`,
                    {
                        // headers: {
                        //   Authorization: await store.dispatch("getAuthorization"),
                        // },
                    }
                )
                .then((res) => {
                    console.log("✅ success");
                    console.log(res.data.message[0]);
                    this.items = res.data.message[0].results;
                    console.log(this.items);
                })
                .catch((err) => {
                    if (err.response) {
                        console.error("❌ API Error:", err.response.status);
                        console.error("Response:", err.response.data);
                    } else {
                        console.error("❌ Error:", err.message);
                    }
                });



        },
        async validationForm() {
            const { username, password, firstname, lastname } = this.formUser;
            const jwt = JSON.parse(localStorage.getItem("company_jwt"));
          //  console.log(jwt);
            !this.showError && this.formUser.companyName && this.formUser.username && this.formUser.password && this.selected && this.formUser.serial
            if (!this.formUser.companyName || !this.formUser.username || !this.formUser.password || !this.selected || !this.formUser.serial) {
                this.showError = true;
                return;
            } else {
                this.showError = false;
            }
            
            const _data = new FormData();
            _data.append("companyName", this.formUser.companyName);
            _data.append("companyPhone", this.formUser.companyPhone);
            _data.append("username", this.formUser.username);
            _data.append("password", this.formUser.password);
            _data.append("role", this.selected);
            _data.append("serial", this.formUser.serial);
            console.log("ddddddddddddd");

            console.log(this.formUser.companyName);
            console.log(this.formUser.companyPhone);
            console.log(this.formUser.username);
            console.log(this.formUser.password);
            console.log(this.selected);
            console.log(this.formUser.serial);

            axios
                .post(`${API}registerCompanies`, _data, {
                    // headers: {
                    //   Authorization: await store.dispatch("getAuthorization"),
                    // },
                })
                .then(async (res) => {
                    console.log(res);
                    if (res.data.message == "Registration company and admin is complete.") {
                        this.$swal({
                            icon: "success",
                            title: "บันทึกข้อมูล!",
                            text: "บันทึกข้อมูลสำเร็จ",
                            showCancelButton: false,
                            showConfirmButton: true,
                            timer: 1500,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                        });
                    }
                })
                .catch(async (error) => {
                    console.log(error.response);

                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: `${error.response.data.message}`,
                            icon: "EditIcon",
                            variant: "danger",
                        },
                    });
                    return;

                });
        },
        async handlePageChange(page) {
            console.log(page);
            this.currentPage = page;
            this.items = [];

            await this.getDataTable();
        },
        async handleItemsPerPageChange() {
            this.items = [];
            this.currentPage = 1;
            await this.getDataTable();
        },
    },
};
</script>